import { combineReducers } from 'redux';
import documents from './documents';
import filters from './filters';
import analytics from './analyticsData';
import application from './application';
import replacements from './replacements';
import jobs from './jobs';
import podcasts from './podcasts';
import acronyms from './acronyms';
import urls from './urls';
import userInfo from './userInfo';
import users from './users';
import groups from './groups';
import podcast from './podcasts';
import historyAudio from './historyAudio';
import historyDocument from './historyDocument';

export default combineReducers({ documents, filters, analytics, application, replacements, jobs, podcasts, acronyms, urls, userInfo, users, groups, podcast, historyAudio, historyDocument });
